<template>
    <div class="flex flex-col flex-1 w-full border border-gray-400 px-3 sm:px-6 py-3 sm:py-6 mb-8">
        <form-row title="Tenant Name" :no_border="true" class="mb-8">
            <input-text
                class="w-full"
                :name="'tenant[' + tenant.id + '][name]'"
                v-model="tenant.name"
                :read_only="read_only"
            />
        </form-row>

        <form-row title="Tenant Rentable Square Footage" :no_border="true" class="mt-2 mb-8">
            <div class="w-56">
                <input-number
                    class="flex-1 mr-6"
                    :name="'tenant[' + tenant.id + '][tenant_square_feet]'"
                    v-model="tenant.tenant_square_feet"
                    :read_only="read_only"
                />
            </div>

            <input-percent
                class="-mt-7"
                label="Tenant Pro Rata Share"
                v-model="tenant_square_feet_percentage"
                :read_only="true"
            />
        </form-row>

        <form-row title="Lease Termination Date" :no_border="true" class="mb-8">
            <input-date
                class="mr-6"
                :name="'tenant[' + tenant.id + '][lease_terminates_at]'"
                v-model="tenant.lease_terminates_at"
                :read_only="read_only"
            />

            <input-radio-boolean
                :name="'tenant[' + tenant.id + '][has_right_to_renew]'"
                label="Right to renew?"
                v-model="tenant.has_right_to_renew"
                class="-mt-2"
                true="Yes"
                false="No"
                :read_only="read_only"
            />
        </form-row>

        <form-row v-if="tenant.has_right_to_renew" title="Renewal Date" :no_border="true" class="mb-8">
            <tenant-renew
                :tenant="tenant"
                :read_only="read_only"
            />
        </form-row>

        <form-row title="Long Term Obligations" :no_border="true" class="mb-8" :label_align_top="true">
            <tenant-long-term-obligations
                :tenant="tenant"
                :property="property"
                :read_only="read_only"
            />
        </form-row>

        <form-row title="Deferred Rent" :no_border="true" class="mb-8" :label_align_top="true">
            <tenant-deferred-rent
                :tenant="tenant"
                :read_only="read_only"
            />
        </form-row>

        <div class="flex flex-1 justify-end">
            <div
                v-if="! read_only"
                class="cursor-pointer flex hover:text-red-600 items-center justify-end text-gray-400 w-6"
                @click="deleteTenant"
            >
                <i class="fas fa-minus-circle"></i>
            </div>
        </div>
    </div>
</template>

<script>
import TenantRenew from './tenant-renew.vue';
import TenantLongTermObligations from './tenant-long-term-obligations.vue';
import TenantDeferredRent from './tenant-deferred-rent.vue';

export default {
    components: {
        TenantRenew,
        TenantLongTermObligations,
        TenantDeferredRent,
    },

    props: {
        read_only: { default: false },
        tenant: {},
        property: {},
    },

    methods: {
        deleteTenant() {
            this.$emit('deleteTenant', this.tenant.id);
        },
    },

    computed: {
        total_square_feet() {
            return store.state.square_feet || null;
        },
        tenant_square_feet_percentage() {
            return this.tenant.tenant_square_feet && this.total_square_feet
                ? Math.min(100, Math.round(
                    parseInt(this.tenant.tenant_square_feet) / parseInt(this.total_square_feet) * 100
                )) : null;
        },
    },
}
</script>
